/* GLHK-12-LIFE-HOTSPOTS-01
 * Read-only interaction over the existing home Hero. No API, auth, tracking,
 * new map, localStorage, pricing or customer writes. Responsive + accessible.
 */
(function (window, document) {
  'use strict';
  const GUARD = '__GLHK_LIFE_HOTSPOTS_RUNTIME_01__';
  if (window[GUARD]) { window[GUARD].mountAll(); return; }
  const ROOT = '[data-glhk-home-hotspots]';
  const SMALL = window.matchMedia('(max-width:1199px), (max-height:640px)');
  const HOVER = window.matchMedia('(hover:hover) and (pointer:fine)');
  const PIN_MODE = window.matchMedia('(min-width:761px) and (min-height:641px)');
  const instances = new WeakMap();
  const activeRoots = new Set();
  const suppressedFocus = new WeakSet();

  function mount(root) {
    if (!root || instances.has(root)) return;
    const world = root.querySelector('[data-hotspot-world]');
    const items = Array.from(root.querySelectorAll('[data-hotspot]')).map(marker => ({
      marker,
      pin: marker.querySelector('[data-hotspot-pin]'),
      panel: marker.querySelector('[data-hotspot-panel]'),
      x: Number(marker.getAttribute('data-scene-x')),
      y: Number(marker.getAttribute('data-scene-y'))
    }));
    const open = root.querySelector('[data-hotspot-open]');
    const close = root.querySelector('[data-hotspot-close]');
    const scrim = root.querySelector('[data-hotspot-scrim]');
    const drawer = root.querySelector('[data-hotspot-drawer]');
    const scroll = root.querySelector('[data-hotspot-drawer-scroll]');
    if (!world || items.length !== 12 || items.some(x => !x.pin || !x.panel || !Number.isFinite(x.x) || !Number.isFinite(x.y)) ||
        !open || !close || !drawer || !scrim || !scroll) return;
    const cleanups = [];
    let active = null;
    let pinned = false;
    let leaveTimer = 0;
    let drawerOpen = false;
    let frame = 0;
    let lastFocused = null;
    const listen = (target, name, fn, opts) => {
      target.addEventListener(name,fn,opts);
      cleanups.push(() => target.removeEventListener(name,fn,opts));
    };

    // The existing background is a single viewport-sized cover image/video
    // with object-position:right bottom. Positions use source screenshot pixels,
    // not % of a page whose height may change with Shopify mobile sheet.
    function project() {
      if (!PIN_MODE.matches) { world.removeAttribute('data-hotspot-projected'); return; }
      const baseW = Number(root.dataset.sceneWidth) || 1671;
      const baseH = Number(root.dataset.sceneHeight) || 941;
      const w = window.innerWidth, h = window.innerHeight;
      const scale = Math.max(w / baseW, h / baseH);
      const left = w - baseW * scale;
      const top = h - baseH * scale;
      // A hotspot must not steal the native homepage CTA or product-card hitbox.
      // Preserve its geographic picture position, hide the obstructed pin rather
      // than shifting it to an unrelated building. Tablet's drawer provides
      // access to all twelve scenes even if the cover crop excludes some pins.
      const hero = root.parentElement && root.parentElement.querySelector('.glg-asia-home__hero');
      const products = root.parentElement && root.parentElement.querySelector('#glg-asia-services');
      const bounds = [hero, products].filter(Boolean).map(el => el.getBoundingClientRect());
      const collides = (x, y) => bounds.some(r =>
        x >= r.left - 22 && x <= r.right + 22 &&
        y >= r.top - 22 && y <= r.bottom + 22
      );
      items.forEach(item => {
        const x = left + item.x * scale;
        const y = top + item.y * scale;
        item.marker.style.left = x.toFixed(2) + 'px';
        item.marker.style.top = y.toFixed(2) + 'px';
        item.pin.disabled = x < 24 || x > w - 24 || y < 24 || y > h - 24 || collides(x,y);
        item.marker.hidden = item.pin.disabled;
      });
      world.setAttribute('data-hotspot-projected','true');
    }
    function scheduleProject() {
      if (frame) return;
      frame = window.requestAnimationFrame(() => { frame=0; project(); });
    }
    function placePanel(item) {
      const panel = item.panel;
      const button = item.pin;
      // Prefer the image side, never obscure the large left-side headline.
      // Keep popovers within the viewport, also on short desktop screens.
      const r = button.getBoundingClientRect();
      const width = panel.offsetWidth || 284;
      const height = panel.offsetHeight || 210;
      const availableRight = window.innerWidth - r.right;
      const rightSide = r.left < window.innerWidth * .65 && availableRight > width + 24;
      const left = rightSide ? 24 : -width - 24;
      const top = (r.top >= height + 20) ? -height - 20 : 18;
      panel.style.left = left + 'px';
      panel.style.top = Math.max(20-r.top, Math.min(top, window.innerHeight - r.top - height - 20)) + 'px';
      // For cropped/off-axis backgrounds still keep card inside the safe frame.
      const popRectLeft = r.left + left;
      if (popRectLeft < 12) panel.style.left = (12 - r.left) + 'px';
      if (popRectLeft + width > window.innerWidth - 12)
        panel.style.left = (window.innerWidth - 12 - width - r.left) + 'px';
    }
    function closePanel() {
      if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = 0; }
      if (!active) return;
      active.panel.hidden = true;
      active.pin.setAttribute('aria-expanded','false');
      active.marker.classList.remove('is-active');
      active = null;
      pinned = false;
      world.classList.remove('is-engaged');
    }
    function showPanel(item) {
      if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = 0; }
      if (!PIN_MODE.matches || item.pin.disabled) return;
      if (active && active !== item) closePanel();
      active = item;
      item.panel.hidden = false;
      item.pin.setAttribute('aria-expanded','true');
      item.marker.classList.add('is-active');
      world.classList.add('is-engaged');
      placePanel(item);
    }
    function togglePanel(item) {
      if (active === item) {
        // Desktop hover already opened the preview; click pins it instead
        // of unexpectedly closing the bubble under the pointer.
        if (pinned) closePanel();
        else pinned = true;
      } else {
        showPanel(item);
        pinned = true;
      }
    }
    function schedulePointerClose(item) {
      if (leaveTimer) clearTimeout(leaveTimer);
      leaveTimer = window.setTimeout(() => {
        leaveTimer = 0;
        if (active === item && !pinned &&
            !item.marker.matches(':hover') &&
            !item.marker.contains(document.activeElement)) closePanel();
      }, 180);
    }

    function showDrawer() {
      if (!SMALL.matches || drawerOpen) return;
      closePanel();
      drawerOpen = true;
      lastFocused = document.activeElement;
      drawer.hidden = false;
      scrim.hidden = false;
      open.setAttribute('aria-expanded','true');
      scroll.scrollTop = 0;
      close.focus({preventScroll:true});
    }
    function hideDrawer() {
      if (!drawerOpen) return;
      drawerOpen = false;
      drawer.hidden = true;
      scrim.hidden = true;
      open.setAttribute('aria-expanded','false');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus({preventScroll:true});
      else open.focus({preventScroll:true});
      lastFocused = null;
    }

    items.forEach(item => {
      listen(item.pin,'click',event => { event.preventDefault(); togglePanel(item); });
      listen(item.marker,'pointerenter', () => { if(HOVER.matches) showPanel(item); });
      listen(item.marker,'pointerleave', () => {
        if (HOVER.matches && active === item && !pinned && !item.marker.contains(document.activeElement)) schedulePointerClose(item);
      });
      listen(item.pin,'focus', () => { if(!suppressedFocus.has(item.pin) && item.pin.matches(':focus-visible')) showPanel(item); });
      listen(item.marker,'focusout',event => {
        if (active === item && !item.marker.contains(event.relatedTarget)) closePanel();
      });
    });
    listen(open,'click',showDrawer);
    listen(close,'click',hideDrawer);
    listen(scrim,'click',hideDrawer);
    listen(document,'pointerdown',event => {
      if (active && !active.marker.contains(event.target)) closePanel();
    });
    listen(document,'keydown',event => {
      if (event.key === 'Escape') {
        if (drawerOpen) { event.preventDefault(); hideDrawer(); }
        else if (active) { event.preventDefault(); const pin = active.pin; closePanel(); suppressedFocus.add(pin); pin.focus({preventScroll:true}); Promise.resolve().then(()=>suppressedFocus.delete(pin)); }
        return;
      }
      if (drawerOpen && event.key === 'Tab') {
        const focusables = Array.from(drawer.querySelectorAll('button:not([disabled]), a[href]'));
        if (!focusables.length) return;
        const first = focusables[0], last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    listen(window,'resize', () => { hideDrawer(); closePanel(); scheduleProject(); },{passive:true});
    const responsiveChange = () => { hideDrawer(); closePanel(); scheduleProject(); };
    listen(SMALL,'change',responsiveChange);
    listen(PIN_MODE,'change',responsiveChange);
    const visibilityChange = () => { if(document.hidden) { hideDrawer(); closePanel(); } };
    listen(document,'visibilitychange',visibilityChange);

    instances.set(root,{
      destroy() {
        hideDrawer(); closePanel();
        if(frame) window.cancelAnimationFrame(frame);
        if(leaveTimer) clearTimeout(leaveTimer);
        cleanups.forEach(fn=>fn());
        instances.delete(root);
        activeRoots.delete(root);
      },
      getState() {return {active: active ? active.marker.dataset.hotspotKey : null,drawerOpen};}
    });
    activeRoots.add(root);
    scheduleProject();
  }
  function mountAll() { document.querySelectorAll(ROOT).forEach(mount); }
  function destroyWithin(node) {
    for (const root of activeRoots) if (node === root || node.contains(root)) instances.get(root)?.destroy();
  }
  document.addEventListener('shopify:section:load',event => { if(event.target) { event.target.querySelectorAll(ROOT).forEach(mount); if(event.target.matches?.(ROOT)) mount(event.target); } });
  document.addEventListener('shopify:section:unload',event => { if(event.target) destroyWithin(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',mountAll);
  else mountAll();
  window[GUARD] = Object.freeze({mountAll});
})(window, document);
